import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("重複修正結果")
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = { class: "text-lg font-bold text-gray-800 mb-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-4 mb-4" }
const _hoisted_6 = { class: "bg-green-50 rounded-md p-3 text-center" }
const _hoisted_7 = { class: "text-2xl font-bold text-green-600" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "成功", -1)
const _hoisted_9 = { class: "bg-red-50 rounded-md p-3 text-center" }
const _hoisted_10 = { class: "text-2xl font-bold text-red-600" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "失敗", -1)
const _hoisted_12 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_13 = { class: "text-sm font-medium text-gray-700 mb-2" }
const _hoisted_14 = { class: "bg-green-50 border border-green-200 rounded-md p-3" }
const _hoisted_15 = { class: "text-sm text-gray-700 font-mono break-all" }
const _hoisted_16 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_17 = { class: "text-sm font-medium text-gray-700 mb-2" }
const _hoisted_18 = { class: "bg-red-50 border border-red-200 rounded-md p-3" }
const _hoisted_19 = { class: "text-sm text-gray-700 font-mono break-all" }
const _hoisted_20 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_21 = { class: "text-sm font-medium text-gray-700 mb-2" }
const _hoisted_22 = { class: "bg-yellow-50 border border-yellow-200 rounded-md overflow-hidden" }
const _hoisted_23 = { class: "w-full text-sm" }
const _hoisted_24 = /*#__PURE__*/_createVNode("thead", { class: "bg-yellow-100" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left text-gray-700" }, "生徒ID"),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left text-gray-700" }, "理由")
  ])
], -1)
const _hoisted_25 = { class: "px-3 py-2 text-gray-600 font-mono text-xs" }
const _hoisted_26 = { class: "px-3 py-2 text-gray-600" }
const _hoisted_27 = {
  key: 3,
  class: "bg-red-50 border border-red-200 rounded-md p-3"
}
const _hoisted_28 = { class: "text-sm text-red-700" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 閉じる ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, {
    size: "wide",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
          return (_openBlock(), _createBlock("div", {
            key: result.schoolDocId,
            class: "border border-gray-200 rounded-lg p-4"
          }, [
            _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.schoolNameMap[result.schoolDocId] || result.schoolDocId), 1),
            _createVNode("div", _hoisted_4, [
              _createVNode("span", {
                class: ["inline-block px-3 py-1 rounded-full text-sm font-medium", _ctx.getStatusBadgeClass(result.status)]
              }, _toDisplayString(_ctx.getStatusLabel(result.status)), 3)
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, _toDisplayString(result.succeededStudentIds?.length ?? 0), 1),
                _hoisted_8
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, _toDisplayString(result.failedStudentIds?.length ?? 0), 1),
                _hoisted_11
              ])
            ]),
            (
              result.succeededStudentIds &&
                result.succeededStudentIds.length > 0
            )
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _createVNode("h4", _hoisted_13, " 成功した生徒ID（" + _toDisplayString(result.succeededStudentIds.length) + "件） ", 1),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("p", _hoisted_15, _toDisplayString(result.succeededStudentIds.join(", ")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (result.failedStudentIds && result.failedStudentIds.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("h4", _hoisted_17, " 失敗した生徒ID（" + _toDisplayString(result.failedStudentIds.length) + "件） ", 1),
                  _createVNode("div", _hoisted_18, [
                    _createVNode("p", _hoisted_19, _toDisplayString(result.failedStudentIds.join(", ")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (
              result.irregularDuplicates &&
                result.irregularDuplicates.length > 0
            )
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  _createVNode("h4", _hoisted_21, " 要手動対応（" + _toDisplayString(result.irregularDuplicates.length) + "件） ", 1),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("table", _hoisted_23, [
                      _hoisted_24,
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(result.irregularDuplicates, (irregular, idx) => {
                          return (_openBlock(), _createBlock("tr", {
                            key: idx,
                            class: "border-t border-yellow-200"
                          }, [
                            _createVNode("td", _hoisted_25, _toDisplayString(irregular.studentDocId), 1),
                            _createVNode("td", _hoisted_26, _toDisplayString(irregular.reason), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (result.errorMessage)
              ? (_openBlock(), _createBlock("div", _hoisted_27, [
                  _createVNode("p", _hoisted_28, _toDisplayString(result.errorMessage), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _hoisted_29
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}